/**
 * Lets the global Esc close the quest tracker's "where to go" panel before anything else
 * (`useGlobalInput`). The panel is not a window, so Esc used to leave it open and pop the game
 * menu instead (E3, 2026-11-03). The tracker sets the closer while the panel is open.
 */
let close: (() => void) | null = null;

export const questTrackerGuidanceEscape = {
  set(closer: (() => void) | null): void { close = closer; },
  /** Closes the panel when it is open; says whether it did. */
  closeIfOpen(): boolean {
    if (!close) return false;
    const closer = close;
    close = null;
    closer();
    return true;
  },
};
